import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { IoMdDocument } from 'react-icons/io';
import { Table, Row, Col, notification, Tooltip, Tag, Typography, Button } from 'antd';
import { getAdeudos } from '../../services/paymentService';
import moment from 'moment';
import { CSVLink } from "react-csv";

import config from '../../config.json';
import { numberFormat } from './../../utils/numberFormat';

const { Title } = Typography;

const headers = [
    { label: "No. Documento", key: "accountingId" },
    { label: "Fecha documento", key: "creationDate" },
    { label: "Precio", key: "price" },
    { label: "Plan", key: "description" },
    { label: "No. servicio", key: "contractId" },
    { label: "Descuento", key: "discount" },
    { label: "Total", key: "total" },
    { label: "Referencia", key: "periodicity" }
];

function Debit() {
    const navigate = useNavigate();
    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(false);
    const controllerRef = useRef(null);

    useEffect(() => {
        return () => {
            controllerRef.current && controllerRef.current.abort()
        }
    }, []);

    const getDataTable = async () => {
        controllerRef.current = new AbortController();
        setLoading(true);
        try {
            const { data } = await getAdeudos({ signal: controllerRef.current.signal });

            if (data.length === 0) {
                notification.success({ message: 'Reporte', description: 'No se encontraron datos.', });
                return;
            }

            setDataSource(data);
        } catch (error) {
            // Ignore aborted requests
            if(error.code && error.code === 'ERR_CANCELED') return;
        }
        finally {
            setLoading(false);
        }
    }

    const columns = [
        { title: 'No. Documento', dataIndex: 'accountingId' },
        { title: 'Fecha documento', dataIndex: 'creationDate', render: (value) => moment(value).format(config.dateFormat) },
        { title: 'Precio', align: 'right', dataIndex: 'price', render: (value) => numberFormat(value) },
        { title: 'Plan', dataIndex: 'description' },
        {
            title: 'No. servicio', dataIndex: 'contractId', align: 'center',
            render: (value) => (
                <Tooltip title="Editar servicio">
                    <Tag className='hand' color="blue" onClick={() => navigate(`/intelinet/servicios/contrato/${value}`)}> &nbsp;{value}&nbsp; </Tag>
                </Tooltip>)
        },
        { title: 'Descuento', align: 'right', dataIndex: 'discount', render: (value) => numberFormat(value) },
        { title: 'Total', align: 'right', dataIndex: 'total', render: (value, record) =>  numberFormat(record.debitCreditIndicator === 'C' ? value * -1 : value) },
        { title: 'Referencia', dataIndex: 'periodicity' },
        { title: 'Doc. referencia', dataIndex: 'parentId' }
    ];

    return (
        <Row gutter={[24, 24]} style={{ marginTop: '2rem', marginLeft: '2rem', marginRight: '2rem' }}>
			<Col span={24}>
				<Title level={2}>Adeudos</Title>
				<hr className="hr-title" />
			</Col>
			<Col span={24}>
				<Row justify="space-between" align="middle">
					<Col>
                        {loading 
                            ? <Button type="ghost" onClick={() => controllerRef.current.abort()}>Cancelar</Button>
                            : <Button icon={<IoMdDocument />} type="primary" onClick={getDataTable}>&nbsp; Generar</Button>}
					</Col>
					<Col>
                        {dataSource.length > 0 && (
                            <CSVLink className="ant-btn ant-btn-primary" data={dataSource} headers={headers} filename="ReporteAdeudos.csv">
                                Descargar reporte
                            </CSVLink>
                        )}
					</Col>
				</Row>
			</Col>
			<Col span={24}>
                <Table rowKey={(record) => `${record.accountingId}${record.accountingDetailId}`} {...{ dataSource, columns, loading}} />
			</Col>
		</Row>
    );
}

export default Debit;